import { Button, Checkbox, Form, Input, Modal, Row, notification } from 'antd'
import './AddDefectListModal.style.less'
import { useMutation } from 'react-query'
import {
  saveDefectList,
  updateDefectList,
} from '../../../DataManagement.transform'
import { queryClient } from '@/config/react-query'
import { isEmptyValue } from '@/utils/common'
import { useEffect } from 'react'

interface Props {
  visible: boolean
  onClose: () => void
  data: any
}

function AddDefectListModal(props: Props) {
  const mutation = useMutation(async (data) => {
    await saveDefectList(data)
  })

  const updateMutation = useMutation(async (data: any) => {
    await updateDefectList(data.id, data.data)
  })

  const onSaveDefectList = async (data) => {
    if (!isEmptyValue(props.data)) {
      await updateMutation.mutateAsync({ id: props.data.id, data })
    } else {
      await mutation.mutateAsync(data)
    }
    await queryClient.refetchQueries(['defect-list'])
    props.onClose()
  }

  useEffect(() => {
    if (updateMutation.isError) {
      const message = (updateMutation.error as any)?.response?.data?.message
      notification.error({
        message: message,
        duration: 3,
        placement: 'top',
      })
    }
  }, [updateMutation.isError])

  return (
    <Modal
      className="modal-add-defect-container"
      open={props.visible}
      width={660}
      footer={false}
      maskClosable={false}
      onCancel={props.onClose}
    >
      <div>
        <p className="title">
          {!isEmptyValue(props.data) ? 'Edit' : 'New'} Defect List
        </p>
        <Form labelCol={{ span: 7 }} onFinish={onSaveDefectList}>
          <Form.Item
            name="name"
            label="Name"
            initialValue={props.data?.name}
            rules={[{ required: true, message: 'This field is required' }]}
          >
            <Input size="large" placeholder="Text" />
          </Form.Item>
          <Form.Item
            name="is_default"
            label="Is Default"
            initialValue={props.data?.is_default}
            valuePropName="checked"
          >
            <Checkbox>Default</Checkbox>
          </Form.Item>
          <Row className="button-container">
            <Button onClick={props.onClose} size="large">
              Cancel
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              loading={mutation.isLoading || updateMutation.isLoading}
            >
              {!isEmptyValue(props.data) ? 'Save' : 'Create'}
            </Button>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default AddDefectListModal
